import script from "./ConfigTopbar.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigTopbar.vue?vue&type=script&setup=true&lang=js"

import "./ConfigTopbar.vue?vue&type=style&index=0&id=28df236a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28df236a"]])

export default __exports__